<template>
    <footer class="content-info mt-5">
    </footer>
</template>

<script>
export default {

}
</script>